import { TypesenseLot } from '@bonhams1793/bonhams-typescript'
import getConfig from 'next/config'

import { ArrowRightIcon } from '@nx/fire/assets'
import { FireLink } from '@nx/fire/link'
import { Body, Heading } from '@nx/fire/typography'
import { getTranslate } from '@nx/translations'
import { useUserInteraction } from '@nx/utils/google-tag-manager'

import { mapLotToLotCardItem } from '@web/helpers/api'

import { LotsPromoGrid } from './LotsPromoGrid'
import {
  StyledFireCard,
  StyledFireCarousel,
  StyledFireImage,
  StyledHeading,
  StyledLabel,
  StyledLotCard,
} from './SimilarLots.styles'
import translate from './SimilarLots.translate.json'

const { publicRuntimeConfig } = getConfig()
const { text } = getTranslate(translate)

export const SimilarLots = ({
  similarLots,
  isFetching,
  variant = 'grid',
}: SimilarLotsProps) => {
  const { recordInteraction } = useUserInteraction()

  if (variant === 'grid') {
    return (
      <LotsPromoGrid
        lots={similarLots}
        isLoading={isFetching}
        event={{
          category: 'Lot Page - Similar Lots',
        }}
      />
    )
  } else {
    const newLots = structuredClone(similarLots)
    newLots.splice(2, 0, {} as TypesenseLot)

    return (
      <>
        <StyledHeading $level={3}>{text('title')}</StyledHeading>
        <StyledFireCarousel fullWidthItems="mobileOnly">
          {newLots.map((lot, index) => {
            if (!lot.lotId) {
              return (
                <StyledFireCard
                  key={`promo-${index}`}
                  Image={
                    <StyledFireImage
                      src="/web-assets/sell-hub-promo.jpg"
                      alt={text('promo.image')}
                      width="100"
                      height="142"
                    />
                  }
                  settings={{
                    imagePadding: false,
                    imagePosition: {
                      desktop: 'left',
                      mobile: 'left',
                    },
                  }}
                >
                  <Heading $level={6}>{text('promo.title')}</Heading>
                  <Body>{text('promo.body')}</Body>
                  <FireLink
                    href={publicRuntimeConfig.SELL_HUB_BASE_URL}
                    onClick={() => {
                      recordInteraction({
                        category: 'Lot Page - Similar Lots (Top)',
                        action: 'sell-hub-card.click',
                        label: '',
                      })
                    }}
                  >
                    <StyledLabel aria-hidden="true">
                      {text('promo.cta')}{' '}
                      <ArrowRightIcon width="25" height="25" />
                    </StyledLabel>
                  </FireLink>
                </StyledFireCard>
              )
            } else {
              return (
                <StyledLotCard
                  key={lot.lotUniqueId}
                  lot={mapLotToLotCardItem(lot)}
                  lotTracking={{ category: 'Lot Page - Similar Lots (Top)' }}
                  isShowingLotId
                  variant="compact"
                />
              )
            }
          })}
        </StyledFireCarousel>
      </>
    )
  }
}

interface SimilarLotsProps {
  similarLots: TypesenseLot[]
  isFetching: boolean
  variant?: 'grid' | 'carousel'
}
